import React from 'react';
import { useCompany } from '@/context/CompanyContext';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/layout/AppSidebar';
import { Caisse } from './Caisse';
import { ShowPricesToggle } from '@/components/caisse/ShowPricesToggle';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Lock } from 'lucide-react';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
export const CaisseWithSidebar: React.FC = () => {
  const {
    userRole,
    loading
  } = useCompany();
  const {
    logout
  } = useAuth();
  const isAdmin = userRole === 'admin';
  const allowedRoles: Array<'admin' | 'member' | 'vendeur'> = ['admin', 'member', 'vendeur'];

  // Éviter le flash en attendant le chargement des données d'entreprise/rôle
  if (loading) {
    return <LoadingSpinner message="Chargement..." />;
  }

  // Si l'utilisateur n'a pas la permission d'accéder à la Caisse, proposer la déconnexion
  if (!userRole || !allowedRoles.includes(userRole)) {
    return <main className="min-h-screen flex items-center justify-center p-4">
        <Card className="max-w-md w-full">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Lock className="h-5 w-5" />
              Accès à la Caisse refusé
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="mb-4 text-muted-foreground">
              Vous n'avez pas la permission d'accéder à cette fonctionnalité.
            </p>
            <Button variant="destructive" className="w-full" onClick={logout}>
              Se déconnecter
            </Button>
          </CardContent>
        </Card>
      </main>;
  }
  if (!isAdmin) {
    // Vendeur / membre: vue caisse classique
    return <Caisse />;
  }

  // Admin: Caisse avec Sidebar + barre d'outils
  return <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <main className="flex-1">
          <Caisse sidebarTrigger={<SidebarTrigger />} />
        </main>
      </div>
    </SidebarProvider>;
};